import { APPLICANT_TYPES } from '../util/constants';
import { useApplicantData } from './useApplicantData';
import { getApplicantData } from '../util/helpers/applicantDataHelper';

const useApplicationMinorOwnersCountries = () => {
  const MainApplicantData = useApplicantData(APPLICANT_TYPES.MAIN);
  const MinorApplicantData = useApplicantData(APPLICANT_TYPES.MINOR);

  const mainIdentityCountry = getApplicantData(
    MainApplicantData,
    'PersonCountry',
    'CountryIso3Code',
  );

  const minorIdentityCountry = getApplicantData(
    MinorApplicantData,
    'PersonCountry',
    'CountryIso3Code',
  );

  return {
    mainIdentityCountry,
    minorIdentityCountry,
  };
};

useApplicationMinorOwnersCountries.propTypes = {};

export default useApplicationMinorOwnersCountries;
